import React from 'react';
import { Drawer } from 'antd';

const GlobalDrawer = ({
  open,           
  onClose,
  drawerHeading,
  children,
  width = 720,
  ...otherProps
}) => {
  return (
    <Drawer
      title={drawerHeading}
      open={open}
      onClose={onClose}
      width={'40vw'}
      styles={{ body: { paddingBottom: 80 } }} 
      {...otherProps}
    >
      {children}
    </Drawer>
  );
};

export default GlobalDrawer;
